import { render, staticRenderFns } from "./LegalBasisEditModal.vue?vue&type=template&id=c9bc3bb4&"
import script from "./LegalBasisEditModal.vue?vue&type=script&lang=js&"
export * from "./LegalBasisEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports